// extracted by mini-css-extract-plugin
export default {"campaign_media_carousel":"CampaignFeature_campaign_media_carousel__mMXGW"};